import classNames from "classnames";
import {
    IsNodeAlreadyComplete,
    todayNodeName,
} from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { CompleteNode } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/CompleteNode/CompleteNode";
import { NavigateTo } from "source/app/presentation/Routing/RouterNavigationTarget";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDragSource } from "source/app/services/Shared/Hooks/useDragSource";
import { IWorkflowNode } from "../../../../../../../../motw_core/Entity/IWorkflowNode";
import Hyperlink from "../../../../Shared/Link/Hyperlink";
import { MaxChildren } from "../../MaxChildren/MaxChildren";
import { NumChildren } from "../NumChildren/NumChildren";
import * as styles from "./ChildNodeName.css";
import { ChildNodeNameText } from "./ChildNodeNameText";
import { WorkflowNodeDeleteDropTarget } from "./DeleteDropTarget/WorkflowNodeDeleteDropTarget";
import { IChildNodeNameProps } from "./IChildNodeNameProps";

export const randomNodeTarget = "Workflows_randomNode";

export function ChildNodeName({
    level,
    rootNode,
    setRootNodeId,
    node,
    children,
    randomNode,
    quizMode,
    scrambledNode,
    limitNameDisplayLength,
}: IChildNodeNameProps) {
    const name = node.name;
    const isRandomNode = node.id === randomNode.id;

    const isIncompleteTodayNode =
        rootNode !== undefined &&
        rootNode.name === todayNodeName &&
        !IsNodeAlreadyComplete(node.name);

    const dragSourceResult = useDragSource(EDragDropObject.workflowNode, node, [
        node.id,
    ]);

    // const [isDeleting, setIsDeleting] = React.useState(true);

    return (
        <span
            className={classNames({
                [styles.randomNode]: isIncompleteTodayNode,
            })}
        >
            <Hyperlink
                id={isRandomNode ? randomNodeTarget : ""}
                whenClicked={() => {
                    setRootNodeId(node.id);
                }}
                classes={classNames([styles.text], {
                    [styles.node]: ShouldshowHoverStyle(node),
                    [styles.bold]: rootNode.id === 0 && level === 0,
                    [styles.randomNode]: isRandomNode,
                    [styles.noChildren]: children.length === 0,
                })}
                hover={false}
            >
                <span
                    ref={dragSourceResult.dragSourceRef}
                    className={classNames({
                        [styles.isDragging]: dragSourceResult.isDragging,
                    })}
                >
                    <ChildNodeNameText
                        node={node}
                        name={name}
                        scrambledNode={scrambledNode}
                        {...{ limitNameDisplayLength, rootNode }}
                    />
                    {/* <IsDeletingIndicator {...{ isDeleting }} /> */}
                </span>
                <WorkflowNodeDeleteDropTarget {...{ node }} />
                <MaxChildren
                    maxChildren={node.maxchildren ? node.maxchildren : 0}
                />
                <NumChildren numChildren={children.length} />
            </Hyperlink>
            {GetHyperLinksFromURLMatches(name)}
            {/* Placed CompleteNode outside main Hyperlink to prevent going to the node when it is clicked (nested hyperlinks) */}
            <CompleteNode node={node} parentNode={rootNode} />
        </span>
    );
}

// function IsDeletingIndicator({ isDeleting }: { isDeleting: boolean }) {
//     if (!isDeleting) {
//         return null;
//     }

//     return (
//         <Glyphicon
//             icon={EGlyphicon.refresh}
//             withClass={StyleClassAuto({
//                 marginLeft: `7px`,
//             })}
//         />
//     );
// }

export function NameWithoutURLs(name: string) {
    var matches = name.match(urlRegex);

    if (matches === null) {
        return name;
    }

    const nameWithoutURLs = name.replace(urlRegex, ``);
    return nameWithoutURLs;
}

export function GetHyperLinksFromURLMatches(name: string) {
    var urls = name.match(urlRegex);

    if (urls === null) {
        return null;
    }

    const url = urls[0].replace(/\s/, ``);
    const isExternalUrl = url.match(/(http(s?)):.*/);

    const ClickAction = isExternalUrl
        ? () => window.open(url, `_blank`)
        : () => NavigateTo(url);

    return (
        <span>
            <Hyperlink whenClicked={ClickAction} key={url} tooltip={url}>
                <Glyphicon
                    icon={EGlyphicon["arrow-right"]}
                    withClass={StyleClass(`workflowNodeHyperlinkArrow`, {
                        opacity: 0.8,
                        marginLeft: `10px`,
                    })}
                />
            </Hyperlink>
        </span>
    );
}

const urlRegex = /\s(http(s?):\/)?\/.*$/;

export const ShouldshowHoverStyle = (node: IWorkflowNode) =>
    node.name.length <= 300;
